import React, { useState, useEffect } from 'react';
import { Form as AntForm } from 'antd';
import styled from 'styled-components';

import { H3 as Title } from 'components/atoms/Text';
import asset from 'utils/asset';
import style from 'utils/style';

const LoginPageContainer = styled.div`
    min-height: 100vh;
    overflow: auto;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    background-color: white;
    font-family: 'Sofia Pro', sans-serif;
`;

const LoginPageInnerContainer = styled.div`
    padding: 40px;
    text-align: left;
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`;

const BottomImage = styled.img`
    position: absolute;
    bottom: 0px;
    width: 25%;
    height: auto;
    display: ${(props) => (props.dimension.width > 725 && props.dimension.height > 470 ? 'block' : 'none')};
`;

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height,
    };
}

const RegisterPassword = () => {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <LoginPageContainer id='loginForm'>
            <div style={{ marginTop: 50, marginBottom: 50 }}>
                <img src={asset.image.ensightfulLogo} alt='Ensightful App Inc.' height={48} />
            </div>
            <LoginPageInnerContainer
                style={{
                    ...style.loginForm,
                }}
            >
                <AntForm
                    style={{
                        width: '456px',
                        height: '320px',
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <div style={{ margin: 'auto' }}>
                        <Title style={{ padding: 20 }} level={4}>
                            <p
                                style={{
                                    fontSize: 25,
                                    fontWeight: '400',
                                    overflowWrap: 'break-word',
                                    textAlign: 'center',
                                }}
                            >
                                Hi there!
                            </p>
                            <p
                                style={{
                                    fontSize: 25,
                                    fontWeight: '400',
                                    overflowWrap: 'break-word',
                                    textAlign: 'center',
                                }}
                            >
                                We are still working on our functionalities for LMS Admins so there's nothing here yet!
                                Stay tuned!
                            </p>
                            <p
                                style={{
                                    fontSize: 16,
                                    fontWeight: '200',
                                    overflowWrap: 'break-word',
                                    textAlign: 'center',
                                }}
                            >
                                If you have any questions regarding Ensightful, please contact us at{' '}
                                <a>info@ensightful.ca</a>.
                            </p>
                        </Title>
                    </div>
                </AntForm>
            </LoginPageInnerContainer>
            <BottomImage
                alt='left_footer_img'
                style={{
                    left: 0,
                }}
                dimension={windowDimensions}
                src={asset.image.loginBackgroundLeft}
                resizemode='contain'
            />
            <BottomImage
                alt='right_footer_img'
                style={{
                    right: 0,
                }}
                dimension={windowDimensions}
                src={asset.image.loginBackgroundRight}
                resizemode='contain'
            />
        </LoginPageContainer>
    );
};

export default AntForm.create({ name: 'RegisterPassword' })(RegisterPassword);
